import { Component } from '@angular/core';
import { AuthService } from '../../../../services/auth.service';
import { SupervisorService } from 'src/app/services/supervisor.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Supervisor } from '../../../../models/supervisor.interface';
@Component({
  selector: 'app-supervisor',
  templateUrl: './supervisor.component.html',
  styleUrls: ['./supervisor.component.scss']
})
export class SupervisorComponent {
  public totalCasosClinicos: number | undefined = 0;
  public totalEnfermeras: number | undefined = 0;
  public totalCanjes: number | undefined = 0;
  public pendientesporasignar: number | undefined = 0;

  constructor(private auth: AuthService, private supervisorService: SupervisorService) {
    if (this.auth.getUsuario?.supervisor?.id) {
      const idSupervisor = this.auth.getUsuario.supervisor.id;
      this.obtenerInformacion(idSupervisor);
    };
  }
  obtenerInformacion(id: number): void {
    this.supervisorService.totales(id).subscribe({
      next: (resp) => {
        this.totalCasosClinicos = resp.datos.casosclinicos;
        this.totalEnfermeras = resp.datos.enfermeras;
        this.totalCanjes = resp.datos.canjes;
        this.pendientesporasignar = resp.datos.pendienteporasignar;
        console.log(resp)
      },
      error: (err: HttpErrorResponse) => { console.log(err.error.message); }
    })
  }
  recargarInformacion(): void {
    if (this.auth.getUsuario?.supervisor?.id) {
      const idSupervisor = this.auth.getUsuario.supervisor.id;
      this.obtenerInformacion(idSupervisor);
    };
  }
}
